export const fields = {
  file: {
    extension: ".csv,.JPEG,.PNG,.PDF,.BMP,.zip,.doc,.docx,.jpg",
    maxFileSize: {
      value_bytes: 10485760, //10メガバイト
    },
  },
} as const;

export default fields;
